import React, { useState } from 'react';
import { RadioInput } from 'components/common/RadioInput';
import {
  Controller,
  useForm,
} from 'react-hook-form';
import { SectionLabel } from 'components/common/SectionLabel';
import {
  ButtonsContainer,
  Spacer,
} from 'components/common/ButtonsContainer';
import { Button } from 'components/common/Button';
import {
  CloseIcon,
  DecimalsLeftIcon,
  DecimalsRightIcon,
} from 'assets/icons';
import {
  StyledButtonContainer,
  StyledContainer,
  StyledFormContainer,
} from 'components/common/Forms/styled';
import { Label } from 'components/common/Input/Label';
import { StyledDecimals } from './styled';
import { toastSuccess } from 'utils/toast';

interface Props {
  metricId: string;
  onClose: () => void;
}

export const MetricFormat = ({ onClose }: Props) => {
  const [decimals, setDecimals] = useState(2);
  // TODO Get metric details when BE ready
  // const { data: metric, isLoading: isLoadingMetric } = useGetMetricQuery(metricId, { refetchOnMountOrArgChange: true });

  const MetricFormats = [
    {
      name: 'Currency',
      value: 'cur',
      annotation: '$000',
    },
    {
      name: 'Number',
      value: 'num',
      annotation: '000',
    },
    {
      name: 'Percentage',
      value: 'per',
      annotation: '0%',
    },
  ];

  const {
    handleSubmit,
    control,
    getValues,
  } = useForm<{ format: { name: string; value: string; annotation: string; } }>({
    mode: 'onChange',
    defaultValues: {
      format: MetricFormats[0], // TODO Get from metric details, when ready
    },
  });

  const handleSaveAndClose = handleSubmit(() => {
    // return updateMetric(data.format)
    //   .unwrap()
    //   .then((result) => {
    toastSuccess('Metric successfully updated.');
    // onClose();
    //   });
  });

  return (
    <StyledContainer>
      <ButtonsContainer alignTop>
        <SectionLabel marginBottom={24}>
          Format
        </SectionLabel>
        <Spacer />
        <Button
          aria-label="Close"
          variant="icon"
          size="large"
          onClick={onClose}
          data-cy="am-button-close"
        >
          <CloseIcon />
        </Button>
      </ButtonsContainer>
      <StyledFormContainer>
        <Controller
          name="format"
          control={control}
          render={({ field }) =>
            <RadioInput
              labelText="Select Number Format"
              valueField="value"
              labelField="name"
              annotationField="annotation"
              defaultValue={getValues().format}
              options={MetricFormats}
              {...field}
            />
          }
        />
        <div>
          <Label
            name="decimals"
            labelText="Select Decimal Format"
          />
          <StyledDecimals>
            <ButtonsContainer>
              <Button
                type="button"
                variant="icon"
                disabled={decimals === 0}
                onClick={() => setDecimals(Math.max(decimals - 1, 0))}
              >
                <DecimalsLeftIcon />
              </Button>
              <Button
                type="button"
                variant="icon"
                disabled={decimals === 2}
                onClick={() => setDecimals(Math.min(decimals + 1, 2))}
              >
                <DecimalsRightIcon />
              </Button>
              <Spacer />
              <span>
                0
                {!!decimals && '.'}
                {!!decimals && Array(decimals)
                  .fill(0)
                  .join('')}
              </span>
            </ButtonsContainer>
          </StyledDecimals>
        </div>
      </StyledFormContainer>
      <StyledButtonContainer pushRight>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          onClick={onClose}
        >
          CANCEL
        </Button>
        <Button
          type="button"
          onClick={handleSaveAndClose}
        >
          SAVE
        </Button>
      </StyledButtonContainer>
    </StyledContainer>
  );
};
